import "./sidebar.css";

import React from "react";
import { useLocation } from "react-router-dom";

import { SidebarDesktop } from "./components/SidebarDesktop/SidebarDesktop";
import { SidebarMobile } from "./components/SidebarMobile";
import { useMobileSidebar } from "./hooks/useMobileSidebar";
import { useUserRole } from "./hooks/useUserRole";

const Sidebar = () => {
  const location = useLocation();
  const { userrole, isAdmin, hasAccess } = useUserRole();
  const {
    isMobile,
    isMobileOpen,
    toggleMobileSidebar,
    closeMobileSidebar,
    handleMenuClick,
  } = useMobileSidebar();

  const isActive = (path) => location.pathname === path;

  if (isMobile) {
    return (
      <SidebarMobile
        isActive={isActive}
        onMenuClick={handleMenuClick}
        userrole={userrole}
        isAdmin={isAdmin}
        hasAccess={hasAccess}
        isMobileOpen={isMobileOpen}
        toggleMobileSidebar={toggleMobileSidebar}
        closeMobileSidebar={closeMobileSidebar}
      />
    );
  }

  return (
    <SidebarDesktop
      isActive={isActive}
      onMenuClick={handleMenuClick}
      userrole={userrole}
      isAdmin={isAdmin}
      hasAccess={hasAccess}
    />
  );
};

export { Sidebar };